module.exports = __webpack_public_path__ + "static/media/banner_drop.e013ab23.png";